import React, { Suspense } from "react"
import { Canvas, useFrame, useLoader, useResource } from "react-three-fiber"
import { Html, OrbitControls, PerspectiveCamera } from "drei"
import { ColladaLoader } from "three/examples/jsm/loaders/ColladaLoader"
import { css } from "styled-components"
import * as THREE from "three"

import { useRoom } from "../../hooks/useRoom.js"

const Model = ({ building, room, ctx }) => {
  const { defaultColor, setDefaultColor, room: oldRoom, setRoom } = ctx
  const dae = useLoader(ColladaLoader, `/3d/${building.toLowerCase()}.dae`)
  const mat = new THREE.MeshBasicMaterial({ color: "#F00" })

  const defaultColorValue = defaultColor()
  const oldRoomValue = oldRoom()

  if (oldRoomValue && oldRoomValue !== room) {
    dae.nodes[oldRoomValue].material = defaultColorValue
    setRoom()
  }

  useFrame(({ clock }) => {
    if (room && defaultColor()) {
      const startColor = new THREE.Color("#ff0000")
      const endColor = new THREE.Color("#00ff00")
      const time = clock.getElapsedTime()
      const value = Math.sin(time * 2.0) * 0.5 + 0.5
      mat.color.copy(startColor).lerpHSL(endColor, value)
    }
  })
  if (room && dae.nodes[room]?.material) {
    setRoom(room)
    setDefaultColor(dae.nodes[room].material)
    dae.nodes[room].material = mat
  }
  return <primitive object={dae.scene} />
}

const D3 = ({ building, room, ctx, ratio }) => {
  const myCamera = useResource()
  return (
    <div
      css={css`
        width: 100%;
        padding-bottom: ${ratio * 100}%;
        background: #80808029;
        position: relative;
        margin: 10px 0;
        border-radius: 10px;
      `}
    >
      <Canvas
        colorManagement
        invalidateFrameloop
        pixelRatio={[1, 2]}
        style={{ position: "absolute" }}
      >
        <PerspectiveCamera ref={myCamera} position={[0, 50, 50]} makeDefault />
        <directionalLight position={[10, 10, 5]} intensity={1} />
        <directionalLight position={[-10, -10, -5]} intensity={1} />
        <OrbitControls
          enableDamping
          enableZoom
          enablePan
          dampingFactor={0.05}
          rotateSpeed={1.05}
          autoRotate
          camera={myCamera.current}
        />
        <Suspense fallback={<Html>Betöltés...</Html>}>
          <Model building={building} room={room} ctx={ctx} />
        </Suspense>
      </Canvas>
    </div>
  )
}

const Three = ({ building, room, ratio = 0.75 }) => {
  const ctx = useRoom()
  // TODO: add available buildings
  const buildings = ["B"]

  if (!building || !buildings.includes(building.toUpperCase())) {
    return null
  }
  return <D3 building={building} room={room} ctx={ctx} ratio={ratio} />
}

export default Three
